export class HistoryTaskUsersConfig{
  // Configuraciones de la tabla
  settings = {};

  constructor() {
    this.settings = {
      mode: 'external',
      noDataMessage: 'La tarea actual no contiene historial',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        usuario: {
          editable: false,
          addable: false,
          class: 'prueba',
          title: 'Resp. agregar/eliminar func. o contratista',
          filter: {
            inputClass: 'form-control',
          },
        },
        responsable: {
          title: 'Funcionario o contratista agregado/eliminado',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        accion: {
          title: 'Acción realizada',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          }
        },
        fecha: {
          title: 'Fecha de la acción',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          }
        }
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/history-task-users/shared/history-task-users.config.service.ts